module.exports = new __parcel__URL__("linkedIn.4489b4d6.svg").toString();